// extracted by mini-css-extract-plugin
export default {"container":"document_form_input_with_select_container__rxsmN","input":"document_form_input_with_select_input__X-UqY","tooltip":"document_form_input_with_select_tooltip__6ohey"};